import isEmpty from 'lodash/isEmpty'
import { Component } from 'preact'
import { withNamespaces } from 'react-i18next'
import Button from 'preact-material-components/Button'
import Elevation from 'preact-material-components/Elevation'
import { connect } from 'preact-redux'
import { selectDates, selectRooms, selectTotalInvoice } from '../../selectors/shoppingCardSelector'
import Divider from '../Divider'
import ShoppingCartDates from './ShoppingCartDates'
import styles from './ShoppingCart.scss'
import ShoppingCartItem from './ShoppingCartItem'

@connect(state => ({
    dates: selectDates(state),
    rooms: selectRooms(state),
    totalInvoice: selectTotalInvoice(state)
}))
class ShoppingCart extends Component {
    handleNextClick = () => {
        this.props.onNextClick()
    }

    render({ dates, rooms, totalInvoice, withoutNextButton, sticky }) {
        const isRoomsEmpty = isEmpty(rooms)
        const style = sticky ? { position: 'sticky', top: '120px' } : {}

        const { t } = this.props

        return (
            <Elevation z={2} class={styles.shoppingCartElevation} style={style}>
                <div class={styles.title}>{t('ShoppingCart.yourbooking')}</div>
                <Divider />

                <div class={styles.orderInfo}>
                    <ShoppingCartDates startDate={dates.startDate} endDate={dates.endDate} nights={dates.nights} />
                </div>

                <Divider />

                <div class={styles.roomList}>
                    {isRoomsEmpty ? (
                        <div class={styles.noRoomsMessage}>{t('ShoppingCart.noselectedrooms')}</div>
                    ) : (
                        rooms.map(room => <ShoppingCartItem room={room} />)
                    )}
                </div>

                {!isRoomsEmpty && (
                    <div class={styles.totalInvoiceWrapper}>
                        <span>{t('ShoppingCart.total')}</span>
                        <span class={styles.totalInvoice}>{rooms[0].currency} {totalInvoice.toFixed(2)}</span>
                    </div>
                )}

                {!withoutNextButton && (
                    <div>
                        <Divider />

                        <Button
                            disabled={isRoomsEmpty}
                            raised
                            class={styles.proceedButton}
                            onClick={this.handleNextClick}
                        >
                            {t('common.continue')}
                        </Button>
                    </div>
                )}
            </Elevation>
        )
    }
}

export default withNamespaces()(ShoppingCart)


// WEBPACK FOOTER //
// ./components/ShoppingCart/ShoppingCart.js